<app-pias-layout>
    <div pias-layout-content>
        <!-- <app-marketing-review-nav></app-marketing-review-nav> -->

        <!-- ═══════════ Page head ═══════════ -->
        <div class="page-header-section">

            <!-- Left Content -->
            <div class="page-header-left">

                <div class="header-icon-badge">
                    <mat-icon>rate_review</mat-icon>
                </div>

                <div class="title-wrapper">
                    <h4 class="page-header">
                        {{ isReadOnly ? 'Advertisement Review' : 'Evaluate Advertisement' }}
                    </h4>
                    <p class="page-subtitle">
                        {{ isReadOnly
                        ? 'This review is closed — the decision and comments are shown below.'
                        : 'Score each criterion, share your comments, then record a decision.' }}
                    </p>
                </div>
            </div>

            <!-- Right Actions -->
            <div class="page-header-right">
                <button type="button" class="back-btn" (click)="goBack()">
                    <mat-icon>arrow_back</mat-icon>
                    Back to dashboard
                </button>
            </div>

        </div>

        <div class="review-stage">

            @if (setSprinner()) {
            <div class="pias-spinner">
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
            }

            @if (notFound) {
            <div class="review-card">
                <div class="review-missing">
                    <mat-icon>error_outline</mat-icon>
                    <p class="review-missing-title">Advertisement not found</p>
                    <p class="review-missing-hint">It may have been removed, or the link is no longer valid.</p>
                    <button type="button" class="btn-primary" (click)="goBack()">Back to dashboard</button>
                </div>
            </div>
            }

            @if (adDetails) {
            <div class="review-card">

                <!-- ═══════════ Header ═══════════ -->
                <div class="review-head">
                    <button type="button" class="icon-btn" aria-label="Back to dashboard" (click)="goBack()">
                        <mat-icon>arrow_back</mat-icon>
                    </button>

                    <div class="review-head-text">
                        <h1 class="review-title">{{ adDetails.marketingTitle }}</h1>
                        <!-- <p class="review-meta">{{ metaLine }}</p> -->
                    </div>

                    <app-ad-status-badge [status]="adDetails.status"></app-ad-status-badge>

                    <span class="review-head-spacer"></span>

                    @if (isReadOnly) {
                    <div class="review-locked">
                        <mat-icon>lock</mat-icon>
                        <span>Review closed</span>
                    </div>
                    } @else {
                    <div class="review-actions">
                        <button type="button" class="btn-reject" (click)="reject()">Reject</button>
                        <button type="button" class="btn-changes" (click)="returnForChanges()">Request changes</button>
                        <button type="button" class="btn-approve" (click)="approve()">Approve</button>
                    </div>
                    }
                </div>

                <!-- ═══════════ Body ═══════════ -->
                <div class="review-body">

                    <!-- ---- Left: the creative ---- -->
                    <section class="media-pane">

                        <!-- ---- Replace material (returned ads, submitter only) ---- -->
                        @if (canReplaceMaterial) {
                        <div class="replace-card">
                            @if (!replacingMaterial) {
                            <div class="replace-prompt">
                                <mat-icon>undo</mat-icon>
                                <p class="replace-prompt-text">
                                    Changes were requested. Replace the material with an amended version
                                    and resubmit it for review.
                                </p>
                                <button type="button" class="replace-start" (click)="startReplaceMaterial()">
                                    <mat-icon>swap_horiz</mat-icon>
                                    Replace material
                                </button>
                            </div>
                            } @else {
                            <div class="replace-head">
                                <span class="replace-title">Replace material</span>
                                <span class="replace-sub">Remove what is outdated, then upload the new version.</span>
                            </div>

                            @for (file of replacementFiles; track file.attachment.documentId) {
                            <div class="replace-row">
                                <span class="replace-thumb" [attr.data-tone]="file.tone">
                                    <mat-icon>{{ file.icon }}</mat-icon>
                                </span>
                                <span class="replace-text">
                                    <span class="replace-name">{{ file.attachment.documentName }}</span>
                                    <!-- <span class="replace-meta">{{ file.meta }}</span> -->
                                </span>
                                <button type="button" class="replace-remove" matTooltip="Remove"
                                    [attr.aria-label]="'Remove ' + file.attachment.documentName"
                                    (click)="removeReplacementFile(file)">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </div>
                            } @empty {
                            <p class="replace-empty">All material removed. Upload the new version to resubmit.</p>
                            }

                            <div class="replace-foot">
                                <label class="replace-upload">
                                    <input type="file" hidden multiple [accept]="ACCEPTED_FILE_TYPES"
                                        (change)="onReplacementFilesSelected($event)" />
                                    <mat-icon>cloud_upload</mat-icon>
                                    Upload new material
                                </label>

                                <span class="replace-spacer"></span>

                                <button type="button" class="btn-comment-ghost" (click)="cancelReplaceMaterial()">
                                    Cancel
                                </button>
                                <button type="button" class="btn-comment"
                                    [disabled]="!replacementFiles.length || !replacementChanged"
                                    (click)="resubmitWithNewMaterial()">
                                    <mat-icon>send</mat-icon>
                                    Resubmit
                                </button>
                            </div>
                            }
                        </div>
                        }

                        <div class="media-toolbar">
                            @if (mediaTabs.length > 1) {
                            <div class="segmented">
                                @for (tab of mediaTabs; track $index) {
                                <button type="button" class="segmented-btn" [class.is-on]="activeMedia === $index"
                                    [matTooltip]="tab.fileName" (click)="selectMedia($index)">
                                    {{ tab.label }}
                                </button>
                                }
                            </div>
                            } @else if (media) {
                            <span class="media-single">{{ media.fileName }}</span>
                            }

                            @if (media && media.kind !== 'image') {
                            <a class="media-open" [href]="media.url" target="_blank" rel="noopener noreferrer"
                                matTooltip="Open in a new tab">
                                <mat-icon>open_in_new</mat-icon>
                            </a>
                            }

                            @if (media && media.pinnable) {
                            <div class="zoom-control">
                                <button type="button" aria-label="Zoom out" [disabled]="!canZoomOut"
                                    (click)="zoomOut()">−</button>
                                <span class="zoom-value">{{ zoom }}%</span>
                                <button type="button" aria-label="Zoom in" [disabled]="!canZoomIn"
                                    (click)="zoomIn()">+</button>
                            </div>
                            }
                        </div>

                        @if (media) {
                        <div class="media-frame">
                            <!-- PDF, images, Word, Excel and PowerPoint render in the browser, where
                                 the reviewer can pin comments to text or an area. -->
                            @if (media.pinnable) {
                            <app-pin-viewer [src]="media.url" [fileName]="media.fileName" [kind]="media.kind"
                                [zoom]="zoom" [pins]="mediaPins" [activePinId]="activePinId"
                                [draft]="mediaDraft" [readOnly]="isReadOnly" (pinDraft)="onPinDraft($event)"
                                (pinSelect)="onPinSelect($event)"></app-pin-viewer>
                            } @else {
                            @switch (media.kind) {

                            @case ('video') {
                            <div class="media-plate is-video">
                                <video [src]="media.url" controls preload="metadata"></video>
                                <p class="media-note">
                                    Playback is scoped to review only. Feedback goes in the comment thread.
                                </p>
                            </div>
                            }

                            <!-- Legacy .doc / .ppt and anything else with no in-browser renderer. -->
                            @default {
                            <div class="media-doc" [attr.data-tone]="media.tone">
                                <span class="media-doc-disc">
                                    <mat-icon>{{ media.icon }}</mat-icon>
                                </span>
                                <p class="media-doc-name">{{ media.fileName }}</p>
                                <p class="media-doc-meta">{{ media.meta }}</p>
                                <p class="media-note">
                                    This format cannot be previewed here — older .doc and .ppt files need to be
                                    saved as .docx or .pptx to pin comments on them. Open the file to review it,
                                    then record your decision here.
                                </p>
                                <a class="media-doc-open" [href]="media.url" target="_blank"
                                    rel="noopener noreferrer">
                                    <mat-icon>open_in_new</mat-icon> Open file
                                </a>
                            </div>
                            }
                            }
                            }
                        </div>
                        } @else {
                        <div class="media-unsupported">
                            <mat-icon>image_not_supported</mat-icon>
                            <p>No creative was attached to this submission.</p>
                        </div>
                        }

                        <!-- ---- Application details ---- -->
                        <!-- Only what the application form actually collects; the uncollected
                             `SaveAdPayload` fields would read as blanks. -->
                        <details class="copy-card" open>
                            <summary class="copy-summary">
                                <mat-icon>subject</mat-icon> Application details
                            </summary>

                            <dl class="copy-list">
                                <dt>Branch name</dt>
                                <dd>{{ adDetails.branchName }}</dd>

                                <dt>Date of application</dt>
                                <dd>{{ adDetails.createdDate }}</dd>

                                <dt>Target recipient(s)</dt>
                                <dd>{{ adDetails.targetRecepients || '—' }}</dd>

                                <dt>Expected date of dissemination</dt>
                                <dd>
                                    @if (adDetails.expectedDateOfDissemination) {
                                    {{ adDetails.expectedDateOfDissemination }}
                                    } @else if (adDetails.expectedCommentOfDissemination) {
                                    {{ adDetails.expectedCommentOfDissemination }}
                                    } @else {
                                    —
                                    }
                                </dd>

                                <dt>Mode of dissemination</dt>
                                <dd>{{ adDetails.modeOfDissemination || '—' }}</dd>
                            </dl>
                        </details>
                    </section>

                    <!-- ---- Right: the reviewer's panel ---- -->
                    <aside class="review-panel">

                        <div class="panel-head">
                            <h2 class="panel-title">Comments</h2>
                            @if (pinTotal) {
                            <span class="panel-pins" matTooltip="Pinned comments still open / pinned in total">
                                <mat-icon>push_pin</mat-icon>
                                {{ pinOpen }} open / {{ pinTotal }}
                            </span>
                            }
                            <span class="panel-count">
                                {{ threadCount }}
                                {{ threadCount === 1 ? 'entry' : 'entries' }}
                            </span>
                        </div>

                        <!-- ---- Thread: comments and decisions, in time order ---- -->
                        <div class="panel-scroll">
                            @if (thread.length) {
                            @for (entry of thread; track entry.key) {

                            @if (entry.kind === 'comment') {
                            <div class="comment is-note" [id]="'thread-comment-' + entry.comment.adId"
                                [class.is-pinned]="entry.comment.pin"
                                [class.is-resolved]="entry.comment.status === 'Resolved'"
                                [class.is-active]="entry.comment.pin && activePinId === entry.comment.adId">
                                <div class="comment-head">
                                    <span class="comment-avatar">{{ initialsOf(entry.comment.commentedBy) }}</span>
                                    <span class="comment-who">
                                        <span class="comment-name">{{ entry.comment.commentedBy }}</span>
                                        <span class="comment-role">
                                            {{ entry.comment.userRole }} ·
                                            {{ entry.comment.createdDate }}
                                            @if (entry.comment.updatedDate) {
                                            · edited
                                            }
                                        </span>
                                    </span>

                                    @if (canModify(entry.comment) && editingCommentId !== entry.comment.adId) {
                                    <span class="comment-actions">
                                        <button type="button" class="comment-action" matTooltip="Edit comment"
                                            (click)="startEdit(entry.comment)">
                                            <mat-icon>edit</mat-icon>
                                        </button>
                                        <button type="button" class="comment-action is-danger"
                                            matTooltip="Delete comment" (click)="deleteComment(entry.comment)">
                                            <mat-icon>delete_outline</mat-icon>
                                        </button>
                                    </span>
                                    }
                                </div>

                                @if (editingCommentId === entry.comment.adId) {
                                <div class="comment-edit">
                                    <textarea rows="3" maxlength="1500" [(ngModel)]="editingText"></textarea>
                                    <div class="comment-edit-actions">
                                        <button type="button" class="btn-comment"
                                            (click)="saveEdit(entry.comment)">Save</button>
                                        <button type="button" class="btn-comment-ghost"
                                            (click)="cancelEdit()">Cancel</button>
                                    </div>
                                </div>
                                } @else {
                                @if (entry.comment.pin; as pin) {
                                <div class="pin-meta">
                                    <span class="pin-no">{{ entry.comment.pin }}</span>
                                    <button type="button" class="pin-ref" matTooltip="Show on the material"
                                        (click)="focusPin(entry.comment)">
                                        <mat-icon>my_location</mat-icon>
                                        {{ pinLocation(pin) }}
                                    </button>
                                    <span class="pin-status" [class.is-resolved]="entry.comment.status === 'resolved'">
                                        {{ entry.comment.status }}
                                    </span>
                                </div>
                                @if (pin.quote) {
                                <blockquote class="pin-quote" (click)="focusPin(entry.comment)">{{ pin.quote }}</blockquote>
                                }
                                }
                                <p class="comment-body">{{ entry.comment.text }}</p>
                                }

                                @if (entry.comment.pin) {
                                @if (entry.comment.status === 'Resolved' && entry.comment.resolvedBy) {
                                <p class="pin-resolved-by">
                                    Resolved by {{ entry.comment.resolvedBy }} ·
                                    {{ entry.comment.resolvedDate | date:'d MMM, h:mm a':'+0800' }}
                                </p>
                                }
                                @if (entry.comment.replayId) {
                                <ul class="pin-replies">
                                    <!-- @for (reply of entry.comment.replies; track reply.id) { -->
                                    <li class="pin-reply">
                                        <span class="comment-avatar is-small">{{ initialsOf(entry.comment.commentedBy) }}</span>
                                        <span class="pin-reply-body">
                                            <span class="comment-name">{{ entry.comment.commentedBy }}</span>
                                            <span class="comment-role">
                                                {{ entry.comment.userRole }} ·
                                                {{ entry.comment.createdDate | date:'d MMM, h:mm a'}}
                                            </span>
                                            <span class="pin-reply-text">{{ entry.comment.replayCommend }}</span>
                                            <span class="pin-reply-text">{{ entry.comment.text }}</span>
                                        </span>
                                    </li>
                                    <!-- } -->
                                </ul>
                                }

                                @if (!isReadOnly) {
                                <div class="pin-reply-box">
                                    <input type="text" maxlength="1000" placeholder="Reply…"
                                        [(ngModel)]="replyText[entry.comment.adId]"
                                        (keydown.enter)="postReply(entry.comment)" />
                                    <button type="button" class="btn-comment-ghost"
                                        [disabled]="!replyText[entry.comment.adId]?.trim()"
                                        (click)="postReply(entry.comment)">Reply</button>
                                </div>
                                <div class="pin-actions">
                                    @if (entry.comment.status === 'resolved') {
                                    <button type="button" class="pin-action" (click)="setPinStatus(entry.comment, 'open')">
                                        <mat-icon>undo</mat-icon> Reopen
                                    </button>
                                    } @else {
                                    <button type="button" class="pin-action is-resolve"
                                        (click)="setPinStatus(entry.comment, 'resolved')">
                                        <mat-icon>check_circle_outline</mat-icon> Resolve
                                    </button>
                                    }
                                </div>
                                }
                                }
                            </div>
                            }

                            @if (entry.kind === 'review') {
                            <div class="comment" [class]="'comment ' + entry.review.decision.toLowerCase()">
                                <div class="comment-head">
                                    <span class="comment-avatar">{{ initialsOf(entry.review.reviewerName) }}</span>
                                    <span class="comment-who">
                                        <span class="comment-name">{{ entry.review.reviewerName }}</span>
                                        <span class="comment-role">
                                            {{ entry.review.reviewerRole }} ·
                                            {{ entry.review.reviewedOn | date:'d MMM, h:mm a':'+0800' }}
                                        </span>
                                    </span>
                                    <app-ad-status-badge [status]="entry.review.decision"></app-ad-status-badge>
                                </div>

                                @if (entry.review.overallComments) {
                                <p class="comment-body">{{ entry.review.overallComments }}</p>
                                } @else {
                                <p class="comment-body is-muted">Decision recorded — see the comments above.</p>
                                }

                                @if (concerns(entry.review).length) {
                                <ul class="comment-concerns">
                                    @for (concern of concerns(entry.review); track concern.key) {
                                    <li>
                                        <span class="concern-label">{{ concern.label }}</span>
                                        @if (concern.remarks) {
                                        <span class="concern-remarks">{{ concern.remarks }}</span>
                                        }
                                    </li>
                                    }
                                </ul>
                                }
                            </div>
                            }

                            }
                            } @else {
                            <p class="panel-empty">No comments yet — start the conversation below.</p>
                            }
                        </div>

                        <!-- ---- Composer ---- -->
                        @if (!isReadOnly) {
                        <div class="composer">
                            <div class="composer-box" [class.is-invalid]="commentsInvalid">
                                <!-- A pin placed on the material waits here until the comment is shared. -->
                                @if (draftPin) {
                                <div class="composer-pin">
                                    <mat-icon>push_pin</mat-icon>
                                    <span class="composer-pin-text">
                                        {{ pinLocation(draftPin) }}
                                        @if (draftPin.quote) {
                                        · “{{ draftPin.quote }}”
                                        }
                                    </span>
                                    <button type="button" class="comment-action" matTooltip="Discard pin"
                                        (click)="discardDraftPin()">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </div>
                                }
                                <textarea #composerInput rows="3" maxlength="1500" [(ngModel)]="overallComments"
                                    (blur)="commentsTouched = true"
                                    [placeholder]="draftPin
                                        ? 'What needs to change here?'
                                        : 'Share your thoughts with the branch — what works, what needs to change, and why'"></textarea>

                                <div class="composer-foot">
                                    <span class="composer-count">{{ overallComments.length }}/1500</span>

                                    <!-- Shares the comment on its own; the decision buttons are in the header. -->
                                    <button type="button" class="btn-comment" [disabled]="!overallComments.trim()"
                                        (click)="postComment()">
                                        <mat-icon>send</mat-icon>
                                        Comment
                                    </button>
                                </div>
                            </div>

                            @if (commentsInvalid) {
                            <p class="composer-error">Please share your comments before recording a decision</p>
                            } @else {
                            <p class="composer-hint">Visible to the submitter and the marketing team</p>
                            }
                        </div>
                        }
                    </aside>
                </div>
            </div>
            }
        </div>
    </div>
</app-pias-layout>
